import { render, staticRenderFns } from "./handPaper.vue?vue&type=template&id=017f0e6a&scoped=true"
import script from "./handPaper.vue?vue&type=script&lang=js"
export * from "./handPaper.vue?vue&type=script&lang=js"
import style0 from "./handPaper.vue?vue&type=style&index=0&id=017f0e6a&prod&lang=scss&scoped=true"
import style1 from "./handPaper.vue?vue&type=style&index=1&id=017f0e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f0e6a",
  null
  
)

export default component.exports